import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from "styled-components";
import { Redirect, withRouter } from "react-router-dom";
import { Button, Card } from '@zebra-fed/zds-react-desktop';
import { AuthContext } from '../authentication/Auth';
import { SSOSettingsContext } from '../authentication/SSOSettings';
import app, { firebaseObj } from '../authentication/firebaseStart';
import { StyledDTRKIcon } from '../styled-components/icons';
import AlertModal from '../components/modals/AlertModal';
import InfoModal from '../components/modals/InfoModal';
//import ShowPassword from '../components/ShowPassword';
import ForgotPasswordModal from '../components/modals/ForgotPasswordModal';
import TextField from '@material-ui/core/TextField';
import config from '../data/application.properties'
import firebaseUtil from '../data/FirebaseUtil';
import pkceUtil from "../data/pkceUtil";
import CircularProgress from "@material-ui/core/CircularProgress";
import { SSO_CONSTANTS, SSO_STATUS_CONSTANTS } from '../data/constants'
import { useTranslation } from "react-i18next";
import { MessageResponseContext } from "../data/MessageLocalizationProvider";
import {logoutSSOUser} from '../Services/userService'
import { getColumnsData } from '../data/userPreferenceData';
var validator = require("email-validator");

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  display: ${props => props.disappear ? `flex` : `none`};
    justify-content: center;
    flex-direction: column;
    align-items: center;
    color: white;
    font-size: 30px;
`;


const StyledWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column; 
    height: 250px;
    margin:250px;
    @media screen and (max-width: 750px) {
        height: 100% !important;
        margin: 0;
    }
`;
const StyledTextContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
`;

const StyledTextError = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    color: red;
`;
const StyledP = styled.p`
    font-size: 14px;
`;
const StyledLink = styled.a`
    color: #1783B4;
    cursor: pointer;
    text-decoration: none;
    height: 12px;
`;
const StyledTextField = styled(TextField)`
    width: 430px;
    border: solid 1px #000000;
    margin-top: 0px;
    padding-left: 4px;
    @media screen and (max-width: 500px) {
        width: 100%;
    }
`;
const StyledHeader = styled.div`
    display: flex;
    border-bottom: #E1E0E1 1.5px solid;
    margin-bottom: 10px;
`;
const StyledContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;
const Header1 = styled.h1`
    font-size: 20px; 
    margin: 0px;
`;

const FieldHeading = styled.h4`
    margin: 0px;
`
const StyledCard = styled(Card)`
  @media screen and (max-width: 750px) {
    box-shadow: none !important;
  }
`;

const firestore = app.firestore();

const LoginPage = (props) => {
    const { currentUser } = useContext(AuthContext);
    const { SSOSettings, refreshSSOSettings } = useContext(SSOSettingsContext);
    const [currentEmail, setCurrentEmail] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [showPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [currentUserLocal, setCurrentUserLocal] = useState(null);
    //const [isAdmin, setIsAdmin] = useState(null);
    const [isManager, setIsManager] = useState(null);
    const [isAdminSuperadminManger, setIsAdminSuperadminManger] = useState(null);
    const [checkErrors, setCheckErrors] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [authCode] = useState(new URLSearchParams(window.location.search).get("code"))
    const [loginType] = useState(new URLSearchParams(window.location.search).get("logintype"));
    const [errorDescription] = useState(new URLSearchParams(window.location.search).get("error_description"))
    const infoModalRef = useRef();
    const [blockLogin, setBlockLogin] = useState(false);
    const [msg, setMsg] = useState('');
    const [userPrompted, setUserPrompted] = useState(false);
    let redirectTo = true;

    const errors = useRef([]);
    const alertModalRef = useRef();
    const forgotPasswordRef = useRef();

    const cardStyles = { minWidth: '360px' };
    const { getKeyItem } = useContext(MessageResponseContext);
    const { t } = useTranslation();

    useEffect(()=>{
        let urlBasedSSOLogout = JSON.parse(localStorage.getItem("urlBasedSSOLogout"));
        if(urlBasedSSOLogout){
            localStorage.removeItem("urlBasedSSOLogout")
            sessionStorage.removeItem("selectedSite");
            app.auth().signOut().then(() => {
                console.log("Successfully Sign Out from Firebase urlBasedSSOLogout")
            }).catch((err) => {
                console.log("Firebase Sign Out Error: " + err)
                return err;
            })
        }
    },[])

    useEffect(() => {
        if (localStorage) {
            localStorage.removeItem("firebase:previous_websocket_failure");
        }
        refreshSSOSettings()
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        console.log("useEffect errorDescription", errorDescription)
        if (errorDescription) {
            let ssoTestStatus = JSON.parse(localStorage.getItem("ssoTestStatus"));
            if (ssoTestStatus && window.opener) {
                localStorage.removeItem("ssoTestStatus");
                localStorage.removeItem("loggedInUserEmail");
                window.opener.postMessage(
                    {
                        success: false,
                        message: t('messages.sso.msg14')
                    }, config.SITE_URL);
                window.close();
            }
        }
    }, [errorDescription]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (authCode)
            signInWithSSONFirebase();
    }, [authCode]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setCurrentUserLocal(currentUser);
    }, [currentUser]);

    useEffect(() => {
        if (currentUserLocal) {
            currentUserLocal.getIdTokenResult().then(response => {
                const isAdminSuperadminManger = response.claims.isAdmin || response.claims.isSuperAdmin || response.claims.isManager;
                const manager = response.claims.isManager;
                let ssoLogin = JSON.parse(localStorage.getItem("ssoLogin"));
                if (manager) {
                    setIsManager(manager);
                    if (response.claims.siteName === "") {
                        console.log("site not assigned")
                        infoModalRef.current.open();
                        setMsg(t('contactAdmin'));
                        setBlockLogin(true);
                        app.auth().signOut();
                    }
                    else {
                        console.log('else cond.')
                        setBlockLogin(false);
                    }
                    console.log(isAdminSuperadminManger, 'isAdminSuperadminManger');
                    console.log(ssoLogin, 'ssoLogin');
                    if (ssoLogin) {
                        /*
                        siteName will be undefine
                         */
                        if (response.claims.siteName === undefined) {

                            infoModalRef.current.open();
                            setMsg(t('contactAdmin'));
                            setBlockLogin(true);
                            app.auth().signOut();
                        }
                        else {
                            if (response.claims.siteName === "") {
                                console.log('else for sso manager if no site ')
                                infoModalRef.current.open();
                                setMsg(t('contactAdmin'));
                                setBlockLogin(true);
                                app.auth().signOut();
                            }
                        }
                    }
                }
                else {
                    setIsManager(null);
                }

                if (!isAdminSuperadminManger && ssoLogin) {
                    setErrorMessage(t('messages.error.err47'));
                    alertModalRef.current.open();
                    app.auth().signOut();
                }
                if (!isAdminSuperadminManger && !ssoLogin) {
                    setErrorMessage(t('messages.error.err21'));
                    alertModalRef.current.open();
                    app.auth().signOut();
                }
                console.log("Admin / Superadmin / Manager is logged in")
                setIsAdminSuperadminManger(isAdminSuperadminManger);
            });
        }

    }, [currentUserLocal]); // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        if (currentUserLocal && isAdminSuperadminManger) {
            let ssoTestStatus = JSON.parse(localStorage.getItem("ssoTestStatus"));
            if (ssoTestStatus && window.opener) {
                return;
            }
            if (isManager) {
                if (blockLogin) {
                    setIsAdminSuperadminManger(null)
                    console.log(blockLogin, 'insde if blockLogin')
                }
                else {
                    redirectTo = false;
                    props.history.push("/dashboard/summary-dashboard");
                }

            }
            else {
                redirectTo = false;
                props.history.push("/dashboard/summary-dashboard");
            }

        }
    }, [isAdminSuperadminManger])

    useEffect(() => {
        if (SSOSettings && SSOSettings.ssoLogin && !authCode && redirectTo && (loginType != 'nonsso')) {
            onLoginClick();
        }
    }, [SSOSettings])

    useEffect(() => {
        if(window.opener) {
            let ssoValidateLoginPopup = localStorage.getItem('ssoValidateLoginPopup');
            if(localStorage.getItem('ssoValidateLoginPopup')) {
                localStorage.removeItem("ssoValidateLoginPopup");
                successPostMessage();
                window.close();
            }
        }
    }, []);

    let successPostMessage = ()=>{
        window.opener.postMessage({
            ssoTestStepStatus: SSO_STATUS_CONSTANTS.SSOTESTSTEPSTATUS.ALL_SUCCESS,
            ssoTestStatus: SSO_STATUS_CONSTANTS.SSOTESTSTATUS.SUCCESS,
            success: true, 
            message: t('messages.sso.msg10')
        }, config.SITE_URL);
    }

    async function signInWithSSONFirebase() {
        setIsLoading(true);
        let codeVerifier = localStorage.getItem("codeVerifier");
        firebaseUtil.getFirebaseTokenFromSSO(authCode, codeVerifier).then(tokenResult => {
            console.log("SSO detail log login success",tokenResult.ssotoken)
            handleLogInSSO(tokenResult.firebasetoken).then((loginResp) => {
                console.log("Logged In Successfully")
                refreshSSOSettings()
                let ssoTestStatus = JSON.parse(localStorage.getItem("ssoTestStatus"));
                if (ssoTestStatus && window.opener) {
                    if(loginResp.claims.isAdmin || !SSOSettings.ssoParameterMappingEnable){
                        let loggedInUser = localStorage.getItem("loggedInUserEmail");
                        let testUser =  loginResp.claims.sub;
                        console.log("testUser === ",testUser);

                        localStorage.removeItem("ssoTestStatus");
                        localStorage.removeItem("loggedInUserEmail");
                        let isLOggedUserSame = false //check if logged user and SSO validate user is same
                        if(loggedInUser === testUser){
                            isLOggedUserSame = true
                        }
                        logoutSSOUser(SSOSettings, isLOggedUserSame)
                        .then(()=>{
                            console.log("Successfully logoutSSOUser");
                            localStorage.removeItem("ssoTestStatus");
                                
                            localStorage.setItem('ssoValidateLoginPopup',true)
                            if(!isLOggedUserSame && (SSOSettings.clientAuthType === 0 || SSO_CONSTANTS.SSO_PROVIDERS.AZURE)) {
                                window.opener.postMessage({
                                    success: true,
                                    message: "LogOut url not valid"
                                }, config.SITE_URL);
                            }else{
                                successPostMessage()
                                window.close();
                            }

                            

                        })
                        .catch(err=>{
                            localStorage.removeItem("ssoTestStatus");
                            let ErrMessage = err.message === "INTERNAL" ? t('messages.error.err45') : err.message
                            window.opener.postMessage(
                                {
                                    success: false,
                                    message: ErrMessage
                                }, config.SITE_URL);
                            window.close();
                        })
                    }else{
                        window.opener.postMessage(
                            {
                                success: false,
                                message: "You are not an admin, please validate with an admin credential also please check the role mapping is entered correctly."
                            }, config.SITE_URL);
                        window.close();
                    }
                } else {
                    localStorage.setItem('ssoLogin', "true");
                }
            }).catch(err => {
                console.error("Error : ", err);
                setIsLoading(false);
                let ssoTestStatus = JSON.parse(localStorage.getItem("ssoTestStatus"));
                if (ssoTestStatus && window.opener) {
                    localStorage.removeItem("ssoTestStatus");
                    window.opener.postMessage(
                        {
                            success: false,
                            message: t('messages.error.err20')
                        }, config.SITE_URL);
                    window.close();
                }
                setErrorMessage(t('messages.error.err20'));
                alertModalRef.current.toggleDialog();
            })
        }).catch(err => {
            console.log("Error :", err);
            console.log("SSO detail log login error",err)
            //alert(JSON.stringify(err))
            let errMsgLocal = err.message ? err.message : err;
            setIsLoading(false);
            let ssoTestStatus = JSON.parse(localStorage.getItem("ssoTestStatus"));
            if (ssoTestStatus && window.opener) {
                localStorage.removeItem("ssoTestStatus");
                // console.log("signInWithSSONFirebase err.message ", err.message);
                console.log("signInWithSSONFirebase err: ", err);
                window.opener.postMessage(
                    {
                        success: false,
                        // message: t(getKeyItem(err.message))
                        message: t(getKeyItem(errMsgLocal))
                    }, config.SITE_URL);
                window.close();
            }
            // setErrorMessage(t('messages.error.err20'));
            if (errMsgLocal == config.ERROR_FETCH_SSO_TOKEN) {
                setErrorMessage(t(getKeyItem("Login-" + errMsgLocal)));
            } else {
                setErrorMessage(t(err));
            }
            alertModalRef.current.toggleDialog();
            setUserPrompted(true);
        });
    }

    async function onLoginClick() {
        console.log("inside onLoginClick... going to redirect");
        console.log("SSOSettings.enablePKCE: "+SSOSettings.enablePKCE);
        var enablePKCE = false;
        if(typeof(SSOSettings.enablePKCE)!="undefined"){
            enablePKCE = SSOSettings.enablePKCE;
        } else {
           if(SSOSettings.clientAuthType===0){
            enablePKCE=true;
           } 
        }
        if(enablePKCE ){
            const codeVerifierAndChallenge = await pkceUtil.codeVerifierAndChallenge();
            localStorage.setItem("codeVerifier", codeVerifierAndChallenge.codeVerifier);

            const ssoURL = `${SSOSettings.authorizationURL}?response_type=code&client_id=${SSOSettings.webClientId}&redirect_uri=${SSOSettings.webRedirectURI}&scope=${encodeURI(SSOSettings.authorizationScope)}&code_challenge=${codeVerifierAndChallenge.challenge}&code_challenge_method=S256`
            console.log("PKCE enabled Redirecting to " + ssoURL)
            window.location.href = ssoURL;

        } else {
            const ssoURL = `${SSOSettings.authorizationURL}?response_type=code&client_id=${SSOSettings.webClientId}&redirect_uri=${SSOSettings.webRedirectURI}&scope=${encodeURI(SSOSettings.authorizationScope)}`
            console.log("PKCE not enabled Redirecting to " + ssoURL)
            window.location.href = ssoURL;
        }
    }

    // async function onSwitchAccountClick() {
    //     const codeVerifierAndChallenge = await pkceUtil.codeVerifierAndChallenge();
    //     localStorage.setItem("codeVerifier", codeVerifierAndChallenge.codeVerifier);

    //     //Logout the current SSO user completely
    //     // eslint-disable-next-line no-unused-vars
    //     const ssourlwithprompt = `${SSOSettings.authorizationURL}?response_type=code&client_id=${SSOSettings.webClientId}&redirect_uri=${SSOSettings.webRedirectURI}&scope=${encodeURI(SSOSettings.authorizationScope)}&code_challenge=${codeVerifierAndChallenge.challenge}&code_challenge_method=S256&prompt=login`;
    //     window.location.href = ssourlwithprompt;
    // }

    async function handleLogInSSO(customToken) {
        errors.current = [];
        //checkForNonSSOErrors(); // force rerender
        // console.log("handleLogIn: Before if block")
        if (errors.current.length === 0) {
            console.log("handleLogIn: setPersistence")
            return new Promise((resolve, reject) => {
                app.auth().setPersistence(firebaseObj.auth.Auth.Persistence.SESSION)
                    .then(() => {
                        setIsLoading(true);
                        app.auth().signInWithCustomToken(customToken).then(async response => {
                            let idTokenResult = await response.user.getIdTokenResult()
                            //console.log(response.user, 'response.user in handle SSO')
                            //console.log(response.user.claims, 'response.user.claims in handle SSO');
                            getColumnsData(response.user.uid);
                            setCurrentUserLocal(response.user);
                            console.log("Successfully signed in with custom token")
                            return resolve({
                                status: true,
                                claims: idTokenResult.claims,
                                msg: t('messages.success.success8') //"Successfully signed in with custom token"
                            })
                        }).catch(error => {
                            let ssoTestError = SSO_CONSTANTS.SSO_TEST_FAILED;
                            console.log("Login error " + JSON.stringify(error))
                            if (error.code === config.ERROR_CODES.USER_NOT_FOUND) {
                                ssoTestError = t('messages.error.err17') //config.USER_NOT_REGISTERED;
                                setErrorMessage(t('messages.error.err17')) //(config.USER_NOT_REGISTERED
                            } else if (error.code === config.ERROR_CODES.WRONG_PASSWORD) {
                                ssoTestError = t('messages.error.err19') //config.USER_INVALID_CREDENTIALS;
                                setErrorMessage(t('messages.error.err19')) //config.USER_INVALID_CREDENTIALS
                            } else {
                                ssoTestError = t('messages.error.err20') //config.USER_LOGIN_FAILED;
                                setErrorMessage(t('messages.error.err20')) // config.USER_LOGIN_FAILED
                            }

                            let ssoTestStatus = JSON.parse(localStorage.getItem("ssoTestStatus"));
                            if (ssoTestStatus && window.opener) {
                                localStorage.removeItem("ssoTestStatus");
                                localStorage.removeItem("loggedInUserEmail");
                                window.opener.postMessage(
                                    {
                                        success: false,
                                        message: ssoTestError
                                    }, config.SITE_URL);
                                window.close();
                            }
                            alertModalRef.current.toggleDialog();
                            return reject(error);
                        }).finally(() => {
                            setIsLoading(false);
                        })
                    })
            })
        }
    }

    async function handleLogIn() {
        errors.current = [];

        if (currentEmail.trim() === "" || !validator.validate(currentEmail)) {
            errors.current = errors.current.concat('email');
        }
        if (currentPassword.trim() === "") {
            errors.current = errors.current.concat('password');
        }
        sessionStorage.removeItem("selectedSite");
        sessionStorage.removeItem("dashboardFilter");

        setCheckErrors(!checkErrors); // force rerender
        if (errors.current.length === 0) {
            app.auth().setPersistence(firebaseObj.auth.Auth.Persistence.SESSION)
                .then(() => {
                    setIsLoading(true);
                    app.auth().signInWithEmailAndPassword(currentEmail, currentPassword).then(response => {
                        getColumnsData(response.user.uid);
                        setCurrentUserLocal(response.user);
                        refreshSSOSettings()
                        localStorage.setItem("compatibilityNotification", "true");
                        localStorage.setItem('ssoLogin', "false");
                    }).catch(error => {
                        console.log("Login error " + JSON.stringify(error))
                        if (error.code === config.ERROR_CODES.USER_NOT_FOUND)
                            setErrorMessage(t('messages.error.err17')) //config.USER_NOT_REGISTERED
                        else if (error.code === config.ERROR_CODES.WRONG_PASSWORD)
                            setErrorMessage(t('messages.error.err19')) //config.USER_INVALID_CREDENTIALS
                        else if (error.code === config.ERROR_CODES.NETWORK_FAILED)
                            setErrorMessage(t('messages.error.err44'))
                        else
                            setErrorMessage(t('messages.error.err20')) //config.USER_LOGIN_FAILED

                        alertModalRef.current.toggleDialog();
                    }).finally(() => {
                        setIsLoading(false);
                    })
                })
        }
    }


    
    let loginJsx = null;
    if (!window.opener) {
        if (SSOSettings){
            if( SSOSettings.ssoLogin && (loginType != 'nonsso')) {
            loginJsx = (<>
                <StyledContainer>
                    <StyledContainer style={{ 'flexDirection': 'column', alignItems: 'flex-end' }}>
                        {/* <StyledP onClick={() => forgotPasswordRef.current.toggleDialog()}><StyledLink>Forgot your password?</StyledLink></StyledP> */}
                        <StyledContainer style={{ flexDirection: 'row' }}>
                            {/* <Button style={{ marginRight: '10px', marginLeft: '15px' }} type="primary" onClick={onSwitchAccountClick}>{t('switchAccount')}</Button> */}
                            <Button style={{ marginRight: '10px' }} type="primary" onClick={onLoginClick}>{t('loginUsingSSO')}</Button>
                        </StyledContainer>
                        {/* <StyledP style={{ marginBottom: "-20px" }} onClick={onSwitchAccountClick} ><StyledLink>{t('switchAccount')}</StyledLink></StyledP> */}
                    </StyledContainer>

                </StyledContainer>
                {/* <StyledContainer >
                    <StyledContainer style={{ 'flexDirection': 'column', alignItems: 'flex-end' }}>
                        <StyledP onClick={onSwitchAccountClick} ><StyledLink>{t('switchAccount')}</StyledLink></StyledP>
                    </StyledContainer>
                </StyledContainer> */}
            </>);
            } else {
                loginJsx = (<>
                    <FieldHeading>{t('userID')}</FieldHeading>
                    <StyledTextField
                        error={errors.current.includes('email')}
                        value={currentEmail}
                        placeholder={t('enterEmail')}
                        onChange={(e) => setCurrentEmail(e.target.value)}
                        type="email"
                        autoComplete="email"
                        helperText={errors.current.includes('email') ? t('validation.rules.emailValidation') : null}
                    />
                    <FieldHeading style={{ marginTop: '8px' }}>{t('password')}</FieldHeading>
                    <StyledTextField
                        error={errors.current.includes('password')}
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        type={showPassword ? "text" : "password"}
                        autoComplete="password"
                        placeholder={t('enterPassword')}
                        helperText={
                            errors.current.includes('password') ? t('validation.rules.passwordValidation1') : null
                        }
                    // InputProps={{
                    //     endAdornment: <ShowPassword showPassword={showPassword} onClick={() => setShowPassword(!showPassword)} size={25}/>
                    // }}
                    />
                    <StyledContainer>
                        <StyledContainer style={{ 'flexDirection': 'column', alignItems: 'flex-end' }}>
                            <StyledP onClick={() => forgotPasswordRef.current.toggleDialog()}><StyledLink>{t('forgotYourPassword')}</StyledLink></StyledP>
                            <StyledContainer style={{ flexDirection: 'row' }}>
                                <Button style={{ margin: '0px' }} type="primary" onClick={handleLogIn}>{isLoading ? t("loading") : t("login")}</Button>
                            </StyledContainer>
                        </StyledContainer>
                    </StyledContainer>
                </>);
            }
        } else {
            loginJsx = (<>
                <StyledContainer>
                    <StyledContainer style={{ 'flexDirection': 'column', alignItems: 'flex-end' }}>
                        {/* <StyledP onClick={() => forgotPasswordRef.current.toggleDialog()}><StyledLink>Forgot your password?</StyledLink></StyledP> */}
                        <StyledContainer style={{ flexDirection: 'column' }}>
                            <StyledTextError>{t('messages.sso.msg18')}</StyledTextError>
                            <StyledTextError>{t('messages.sso.msg19')}</StyledTextError>
                        </StyledContainer>
                        {/* <StyledP style={{ marginBottom: "-20px" }} onClick={onSwitchAccountClick} ><StyledLink>{t('switchAccount')}</StyledLink></StyledP> */}
                    </StyledContainer>

                </StyledContainer>
            </>);
        }
    }



    function onDialogButtonClick() {
        console.log('userprompted:', userPrompted);
        if (userPrompted) {
            setUserPrompted(false);
            onLoginClick();
        }
    }

    return (
        <>
            <AlertModal modalRef={alertModalRef} message={errorMessage} onDialogClose={onDialogButtonClick} />
            <InfoModal modalRef={infoModalRef} msg={msg} />

            <ForgotPasswordModal modalRef={forgotPasswordRef} />
            <DarkBackground disappear={isLoading}>
                <CircularProgress style={{color:"white"}} />
                <div>{t('loginInProgress')}</div>
            </DarkBackground>
            {(loginType != 'nonsso') && (SSOSettings && SSOSettings.ssoLogin || window.opener) ? t('loading__') :
                (
                    <StyledWrapper>
                        {/*ref: https://codesandbox.io/s/react-loading-overlay-3w274?from-embed=&file=/src/index.js:1235-2037*/}
                        <StyledCard
                            className='loginCard'
                            type="primary"
                            style={cardStyles}
                        >
                            <StyledHeader>
                                <StyledDTRKIcon style={{ height: '70px' }} />
                                <div>
                                    <Header1 style={{ margin: '25px' }}>{t('deviceTracker')}</Header1>
                                </div>
                            </StyledHeader>
                            {loginJsx}
                        </StyledCard>
                        <StyledTextContainer>
                            <StyledP style={{ 'textAlign': 'center' }}>{t('disclaimerText1')}<br />
                                <StyledLink href="https://www.zebra.com/us/en/about-zebra/company-information/legal/terms-of-use.html">{t('terms_and_conditions')} </StyledLink>
                                {t('and')}
                                <StyledLink href="https://www.zebra.com/us/en/about-zebra/company-information/legal/privacy-statement.html#">{t('privacyPolicy')} </StyledLink>
                            </StyledP>
                        </StyledTextContainer>
                    </StyledWrapper>)}
        </>
    )
}

export default withRouter(LoginPage);